import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function BottomNav({ active }) {
  const navigate = useNavigate();

  const items = [
    { id: 'rates',   icon: 'ti-chart-bar',  label: 'Live Rates', path: '/dashboard' },
    { id: 'forward', icon: 'ti-trending-up', label: 'Forward',   path: '/forward'   },
    { id: 'alerts',  icon: 'ti-bell',        label: 'Alerts',    path: '/alerts'    },
    { id: 'profile', icon: 'ti-user',        label: 'Profile',   path: '/profile'   },
  ];

  // Colours for each tab — matching top bar theme
  const colors = {
    rates:   '#3B82F6', // Blue
    forward: '#22C55E', // Green
    alerts:  '#F59E0B', // Amber
    profile: '#C9A84C', // Gold
  };

  return (
    <div style={s.nav}>
      {items.map(item => {
        const isActive = active === item.id;
        const color    = colors[item.id];
        return (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            style={{
              ...s.btn,
              background: isActive
                ? color + '15'
                : 'transparent',
            }}
            aria-label={item.label}>

            {/* Active top indicator bar */}
            {isActive && (
              <div style={{
                ...s.topBar,
                background: color,
              }} />
            )}

            {/* Icon */}
            <i
              className={'ti ' + item.icon}
              style={{
                fontSize: '22px',
                color:    isActive ? color : '#6B7280',
                display:  'block',
              }}
              aria-hidden="true"
            />

            {/* Label */}
            <span style={{
              ...s.label,
              color:      isActive ? color : '#6B7280',
              fontWeight: isActive ? 700 : 400,
            }}>
              {item.label}
            </span>

          </button>
        );
      })}
    </div>
  );
}

const s = {
  nav: {
    position:      'fixed',
    bottom:        0,
    left:          0,
    right:         0,
    background:    '#1B3A6B',
    borderTop:     '1px solid #1E3050',
    display:       'flex',
    zIndex:        200,
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  btn: {
    flex:           1,
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        '8px 0 10px',
    border:         'none',
    cursor:         'pointer',
    position:       'relative',
    transition:     'background 0.2s',
    borderRadius:   '0px',
  },
  topBar: {
    position:     'absolute',
    top:          0,
    left:         '20%',
    right:        '20%',
    height:       '3px',
    borderRadius: '0 0 4px 4px',
  },
  label: {
    fontFamily: 'Arial',
    fontSize:   '10px',
    marginTop:  '3px',
    letterSpacing: '0.02em',
  },
};